<template>
  <div class="view-portal-home">
    <header-preview
      :module="portalHeader"
      :description="headerDescription"
      :additional-info="additionalInfo"
    />

    <div class="container-fluid pt-5">
      <div v-if="!contents.length" class="empty text-center py-5">
        Nenhum conteúdo disponível no momento.
      </div>

      <template v-else>
        <h5 class="page-title mb-3">Todos os conteúdos</h5>

        <div class="row">
          <div
            v-for="content in unlockedContents"
            :key="`unlocked-${content.product_id}`"
            class="col-6 col-md-4 col-lg-3 col-xl-2 mb-4"
          >
            <portal-content-card :content="content" />
          </div>

          <div
            v-for="content in lockedContents"
            :key="`locked-${content.product_id}`"
            class="col-6 col-md-4 col-lg-3 col-xl-2 mb-4"
          >
            <portal-locked-card :content="content" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import get from "lodash/get";
import HeaderPreview from "@/components/preview/HeaderPreview";
import PortalContentCard from "@/components/portal/PortalContentCard";
import PortalLockedCard from "@/components/portal/PortalLockedCard";
import activeContentHeader from "@/mixins/activeContentHeader";

export default {
  name: "PortalHome",
  mixins: [activeContentHeader],
  components: { HeaderPreview, PortalContentCard, PortalLockedCard },
  computed: {
    ...mapState("portal", ["contents"]),
    ...mapGetters("portal", ["unlockedContents", "lockedContents"]),
    title() {
      return get(this.setup, "name") || "Meus conteúdos";
    },
    portalHeader() {
      return { ...this.headerConfig, name: this.title };
    },
    additionalInfo() {
      const total = this.contents.length;

      return total === 1 ? "1 conteúdo" : `${total} conteúdos`;
    }
  }
};
</script>

<style lang="scss" scoped>
.view-portal-home {
  .empty {
    opacity: 0.7;
  }
}
</style>
